import * as React from "react";
const SvgFiRrTowerControl = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tower-control_svg__a)">
      <path
        fill="#062147"
        d="M23.093 7.464A3.98 3.98 0 0 0 20 6h-4V5c0-1.654-1.345-3-3-3V1a1 1 0 1 0-2 0v1C9.347 2 8 3.346 8 5v1H4.001c-1.203 0-2.33.533-3.093 1.464a3.98 3.98 0 0 0-.829 3.32l.72 3.599A4.51 4.51 0 0 0 5.211 18h2.79v3c0 1.654 1.345 3 3 3h2c1.654 0 3-1.346 3-3v-3h2.788a4.51 4.51 0 0 0 4.412-3.617l.72-3.599a3.98 3.98 0 0 0-.828-3.32m-1.547 1.268c.381.466.532 1.07.415 1.66L21.639 12H16V8h4c.602 0 1.165.267 1.546.731zM10 12.001v-4h4v4zm1-8h2a1 1 0 0 1 1 1v1h-4v-1a1 1 0 0 1 1-1m-8.546 4.73A1.99 1.99 0 0 1 4.001 8h4v4H2.361l-.322-1.608a2 2 0 0 1 .415-1.66zM14.001 21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h4zm4.789-5H5.21a2.506 2.506 0 0 1-2.449-2h18.476a2.506 2.506 0 0 1-2.448 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tower-control_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTowerControl;
